import Input from './Input';
import Group from './Group';

Input.Group = Group;
export default Input;



// WEBPACK FOOTER //
// ./_antd1.11.2/input/index.jsx